module.exports = __webpack_public_path__ + "img/LSG_Logo.e0e150ad.svg";